export const resources = {
  junior: {
    macos: [
      { name: 'Product Design Fundamentals', url: 'https://www.interaction-design.org/literature/topics/product-design', type: 'fundamentals' },
      { name: 'Design Thinking Process', url: 'https://designthinking.ideo.com/', type: 'methodology' },
      { name: 'User-Centered Design', url: 'https://www.nngroup.com/articles/user-centered-design/', type: 'user-centered' },
      { name: 'Figma for Product Design', url: 'https://www.figma.com/resources/learn-design/', type: 'tools' }
    ],
    windows: [
      { name: 'Microsoft Design Principles', url: 'https://docs.microsoft.com/en-us/windows/apps/design/', type: 'principles' },
      { name: 'Sketch for Windows Alternatives', url: 'https://www.figma.com/', type: 'tools' },
      { name: 'Adobe Creative Suite', url: 'https://www.adobe.com/creativecloud.html', type: 'tools' },
      { name: 'Windows Design Guidelines', url: 'https://docs.microsoft.com/en-us/windows/apps/design/signature-experiences/', type: 'guidelines' }
    ],
    linux: [
      { name: 'Open Source Design Tools', url: 'https://github.com/LisaDziuba/Awesome-Design-Tools', type: 'tools' },
      { name: 'GIMP for Product Design', url: 'https://www.gimp.org/', type: 'tools' },
      { name: 'Inkscape Vector Design', url: 'https://inkscape.org/', type: 'tools' },
      { name: 'Blender for 3D Design', url: 'https://www.blender.org/', type: 'tools' }
    ]
  },
  mid: {
    macos: [
      { name: 'Advanced Product Strategy', url: 'https://www.productplan.com/learn/', type: 'strategy' },
      { name: 'Design Systems Architecture', url: 'https://designsystemsrepo.com/', type: 'design-systems' },
      { name: 'Product Analytics for Designers', url: 'https://amplitude.com/blog/product-design-analytics/', type: 'analytics' },
      { name: 'Advanced Prototyping', url: 'https://www.framer.com/academy/', type: 'prototyping' }
    ],
    windows: [
      { name: 'Power Platform for Designers', url: 'https://powerapps.microsoft.com/en-us/blog/category/design/', type: 'tools' },
      { name: 'Azure Design Patterns', url: 'https://docs.microsoft.com/en-us/azure/architecture/patterns/', type: 'patterns' },
      { name: 'Microsoft Fluent Design', url: 'https://www.microsoft.com/design/fluent/', type: 'design-system' },
      { name: 'Advanced Adobe Tools', url: 'https://www.adobe.com/products/xd.html', type: 'tools' }
    ],
    linux: [
      { name: 'Advanced Open Source Design', url: 'https://github.com/topics/design-tools', type: 'tools' },
      { name: 'Web-based Design Platforms', url: 'https://www.figma.com/', type: 'web-tools' },
      { name: 'Design Automation Scripts', url: 'https://github.com/topics/design-automation', type: 'automation' },
      { name: 'Linux Design Workflow', url: 'https://opensource.com/article/17/2/linux-design-tools', type: 'workflow' }
    ]
  },
  senior: {
    macos: [
      { name: 'Design Leadership', url: 'https://www.designbetter.co/design-leadership-handbook', type: 'leadership' },
      { name: 'Product Strategy & Vision', url: 'https://www.productplan.com/learn/product-strategy/', type: 'strategy' },
      { name: 'Design Operations', url: 'https://www.designbetter.co/design-ops-handbook', type: 'operations' },
      { name: 'Advanced Design Systems', url: 'https://atomicdesign.bradfrost.com/', type: 'systems' }
    ],
    windows: [
      { name: 'Enterprise Design Strategy', url: 'https://www.microsoft.com/design/', type: 'enterprise' },
      { name: 'Design at Scale', url: 'https://docs.microsoft.com/en-us/azure/architecture/guide/design-principles/', type: 'scaling' },
      { name: 'AI-Assisted Design', url: 'https://docs.microsoft.com/en-us/azure/cognitive-services/computer-vision/', type: 'ai-design' },
      { name: 'Cross-Platform Design', url: 'https://docs.microsoft.com/en-us/xamarin/xamarin-forms/', type: 'cross-platform' }
    ],
    linux: [
      { name: 'Open Source Design Leadership', url: 'https://github.com/opensourcedesign', type: 'leadership' },
      { name: 'Design Infrastructure', url: 'https://github.com/topics/design-infrastructure', type: 'infrastructure' },
      { name: 'Automated Design Systems', url: 'https://github.com/topics/design-tokens', type: 'automation' },
      { name: 'Community-Driven Design', url: 'https://opensourcedesign.net/', type: 'community' }
    ]
  }
};
